var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85363 0.146576C8.04889 0.341837 8.04889 0.658418 7.85363 0.853679L0.853572 7.85355C0.658306 8.04882 0.341716 8.04882 0.14645 7.85355C-0.0488163 7.65829 -0.0488162 7.34171 0.14645 7.14645L7.14651 0.146576C7.34177 -0.0486856 7.65836 -0.0486856 7.85363 0.146576Z",
    fill: "#6E6E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85363 7.85343C7.65836 8.04869 7.34177 8.04869 7.14651 7.85343L0.14645 0.853549C-0.0488164 0.658288 -0.0488166 0.341707 0.14645 0.146446C0.341716 -0.0488154 0.658305 -0.0488152 0.853571 0.146446L7.85363 7.14632C8.04889 7.34158 8.04889 7.65816 7.85363 7.85343Z",
    fill: "#6E6E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a88a8cc18793da26d10d72760c456f6b.svg";
export { ForwardRef as ReactComponent };